import type { WhiteboardSessionSnapshot } from "@klass-share/whiteboard-core";

export interface WhiteboardEditingContext {
  readonly sessionAvailable: boolean;
  readonly pageAvailable: boolean;
  readonly drawingVerified: boolean;
  readonly snapshot: WhiteboardSessionSnapshot | undefined;
}

export function whiteboardEditingEnabled(
  context: WhiteboardEditingContext,
): boolean {
  return (
    context.sessionAvailable &&
    context.pageAvailable &&
    context.drawingVerified &&
    context.snapshot?.hostTimeAnchored === true &&
    context.snapshot.boardLocked !== true
  );
}
